import React from 'react';
import Modal from '../modal/Modal';
import TeamForm from '../team/form';
import AcceptModal from "../accept_modal/AcceptModal";
import SearchForm from "../searchForm/SearchForm";
import { toast, ToastContainer } from "react-toastify";
import TeamsApi from "../../api/Teams";
import LeaguesApi from "../../api/Leagues";
import CaptainsApi from "../../api/Captains";
import CaptainForm from './CaptainForm';
import { Link } from 'react-router-dom';

export default class Captains extends React.Component{
    teams = [];
    leagues = [];
    constructor(){
        super();
        this.state = {
            showModal: false,
            data: [],
            modalTitle: "",
            selected: null,
            showAcceptModal: false,
            filterText: "",
            addPlayersModal: false
        };
    }

    componentWillMount(){
        let st = {...this.state};
        CaptainsApi.getAll().then(r => {
            if(r.data.response.length>0)
                st.data = r.data.response;
            else
                st.data = [];
            this.setState(st);
        });
        LeaguesApi.getAll().then(r => {
            this.leagues = r.data.response;
        }).catch(err => toast.warn('Atención, No hay ligas dadas de alta para incluir a los equipos.'));
        TeamsApi.getAll().then(r => {
            var ar = this.getOptions(r.data.response.filter(t => t.status !=0));
            this.teams = ar;
        }).catch(err => toast.warn('Atención, No hay ligas dadas de alta para incluir a los equipos.'));
    }

    getOptions = (input) => {
        var obj = input
        var arr = [];
        for (var key in obj) {
            // if(obj[key]["value"]==input.value && flag==false && obj[key]["team"])
            arr.push({"label": obj[key]["team"]+" -- "+ obj[key]["league"],"value":obj[key]["id"], "league_id": obj[key]["league_id"]});
            // else
            //     if(obj[key]["value"]==input.value && flag==false && !obj[key]["team"])
            //         arr.push({"label": obj[key]["label"],"value":obj[key]["value"],disabled: true});
            //     else
            //         if(flag==false)
            //             arr.push({"label": obj[key]["label"],"value":obj[key]["value"],"league_id":obj[key]["league_id"],"tournament":obj[key]["tournament"]});
            //         else
            //             arr.push({"label": obj[key]["team"]+" -- "+ obj[key]["league"]+' -- '+obj[key]["tournament"],"value":obj[key]["id"],"league_id":obj[key]["league_id"],"tournament": obj[key]["tournament"]});
        }
        return arr;
    }

    edit(team){
        let st = {...this.state}
        st.modalTitle = "Editar";
        st.showModal = true;
        st.selected = team;
        this.setState(st);
    }

    closeModal(){
        let st =this.state;
        st.showModal = false;
        this.setState(st);
    }

    save(data,closeModal=false){
        let state = {...this.state};
        //validate inputs
        if(data.email=="" || data.password=="" || data.team=="" || data.league_id==""){
            toast.error("Llene todos los campos para poder continuar.");
            return;
        }
        CaptainsApi.create(data).then(res => {
            if(res.data.response==false){
                toast.error("El usuario ya existe.");
                return;
            }else{
                toast.success("Guardado Exitosamente.");
            }
            state.data.push(res.data.response.data);
            state.showModal = false;
            this.setState(state)
            return;
        }).catch(err => console.log(err));
    }

    update(data){
        let state = {...this.state};
        //validate inputs
        CaptainsApi.edit(data).then(res => {
            if(res.data.response==false){
                toast.error("El usuario ya existe.");
                return;
            }else{
                toast.success("Guardado Exitosamente.");
            }
            let index = state.data.findIndex(d => d.id==res.data.response.data.id);
            state.data[index].email = res.data.response.data.email
            state.showModal = false;
            this.setState(state)
            return;
        }).catch(err => console.log(err));
    }


    create(){
        let st = this.state
        st.modalTitle = "Nuevo";
        st.showModal = true;
        st.selected = null;
        this.setState(st);
    }

    remove(){
        CaptainsApi.delete(this.state.selected.id).then(res=>{
            if(res.data.response){
                let state = {...this.state};
                state.data.splice(state.data.findIndex(t => t.id === this.state.selected.id),1);
                state.selected = null;
                state.showAcceptModal = false;
                this.setState(state);
                toast.success("Capitán eliminado");
            }else{
                toast.error('Ocurrió un problema, intente más tarde');
            }
        })
    }

    delete(captain){
        let state = {...this.state};
        state.showAcceptModal = true;
        state.selected = captain;
        this.setState(state);
    }

    handleSearchInput(text){
        // let teams = this.teams.filter(team => team.team.toLowerCase().includes(text.toLowerCase())||
        // team.league.toLowerCase().includes(text.toLowerCase())||
        // team.tournament.toLowerCase().includes(text.toLowerCase()));
        // let state = this.state;
        // state.filterText = text;
        // state.data = teams;
        // this.setState(state);
    }

    render(){
        return(
            <div className="card-content">
                <div className="columns">
                    <div className="column">
                        <div className="field">
                            <div className="control">
                                {/* <SearchForm
                                    filterText={this.state.filterText}
                                    onInput={(t) => this.handleSearchInput(t)}
                                    itemName={'equipo'}
                                /> */}
                            </div>
                        </div>
                    </div>
                    <div className="column">
                        <div className="field">
                            <div className="control">
                                <a className="button is-outlined is-primary" onClick={(e) => this.create()}>Agregar capitán</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="columns">
                    <div className="column">
                        <table className="table is-fullwidth">
                            <thead>
                            <tr>
                                <th>Id</th>
                                <th>Usuario</th>
                                <th>Equipo</th>
                                <th>Liga</th>
                                <th>Torneo</th>
                                <th>Acciones</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.data.length>0 && this.state.data.map(d => {
                                return(
                                    <tr key={d.id}>
                                        <th>{d.id}</th>
                                        <th>{d.email}</th>
                                        <td><Link to={'/Detalles/equipo/'+d.id}>{d.team}</Link></td>
                                        <td>{d.league}</td>
                                        <td>{d.tournament}</td>
                                        <td>
                                            <a className="button is-warning" onClick={(e) => this.edit(d)}>
                                                <span className="icon is-small">
                                                    <i className="fas fa-edit"/>
                                                </span>
                                            </a>
                                            <a className="button is-danger" onClick={(e) => this.delete(d)}>
                                                <span className="icon is-small">
                                                    <i className="fas fa-trash"/>
                                                </span>
                                            </a>
                                        </td>
                                    </tr>

                                )
                            })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
                {this.state.showModal &&
                <Modal
                    showModal={this.state.showModal}
                    modalTitle={this.state.modalTitle}
                    data = {this.state.data}
                    cancel={() => this.closeModal()}
                >
                    <CaptainForm
                        selected = { this.state.selected }
                        cancel={() => this.closeModal()}
                        save={(t)=>this.save(t)}
                        edit={(t)=>this.update(t)}
                        leagues={this.leagues}
                        teams={this.teams}
                    />
                </Modal>
                }
                {this.state.showAcceptModal &&
                <AcceptModal
                    isActive={this.state.showAcceptModal}
                    done={(t) => this.remove(t)}
                    cancel={() => {
                        let state = {...this.state};
                        state.showAcceptModal = false;
                        this.setState(state);
                    }}
                    body={"¿Está seguro de eliminar al capitan "+this.state.selected.email+"?"}
                    modalTitle={"Eliminar capitán"}
                />
                } 
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/captains/Captains.js